<template>
  <div class="flex flex-row justify-center items-center">
    <p class="text-gray-700 text-base mr-1">
      Call
    </p>
    <a class="text-blue-400 mr-1" href="tel:+17604047532">760-404-7532</a>
    <p class="text-gray-700 text-base mr-1">
      or
    </p>
    <a
      class="text-blue-400 mr-1"
      href="mailto:erikdyrr@live.com?subject=Contact%20Inquiry"
      >email us!</a
    >
  </div>
</template>

<script>
export default {
  name: "CommunicationCard"
};
</script>

<style scoped></style>
